import Vue from "vue";
import Vuex from "vuex";
import module from "./module";
import createPersistedState from "vuex-persistedstate";
//import SecureLS from "secure-ls";
//const ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);
Vue.config.devtools = true;
const store = new Vuex.Store({
  state: {
    dataProjects:[],
    openOneTrack:false,
    storeName: "",
    alertValues: { errorMsg: "", variant: "" },
    showAlert: false,
    isBusy: false,
    sequence: "",
    providerObservation: "",
    observation: "",
    product: { sku: "", cantidad: "" },
    listServices: [{ turno: "", quantity: "", fecha: "" }],
    listSkuServices: [],
    isLoading: false,
    dataClienteDNI: {
      storeCode: null,
      id: 0,
      names: "",
      identityDocument: "",
      lastName: "",
      motherLastName: "",
      dadDocumentType: "",
      phone: "",
      comercialPhone: "",
      personalPhone: "",
      directions: [{ district: "" }],
      mails: [],
      phones: [],
    },
    dataClienteNV: null,
    dataAdminOS: []
  },
  getters: {
    skuServices(state) {
      return state.listSkuServices;
    },
    listServices(state) {
      return state.listServices;
    },
    product(state) {
      return state.product;
    },

  },
  mutations: {
    SET_OPEN_PAGE(state,val){
      state.openOneTrack=val
    },
    SET_ERROR_MSG(state, val) {
      state.alertValues.errorMsg = val.msg;
      state.alertValues.variant = val.variant;
    },
    setShowAlert(state, val) {
      state.showAlert = val;
    },

    ADD_CONTACT_PHONE(state, val) {
      state.dataClienteDNI.phones.push(val);
    },
    ADD_CONTACT(state, val) {

      state.dataClienteDNI.mails.push(val);
    },
    ADD_DIRECTION(state, val) {
      state.dataClienteDNI.directions.push(val);
    },
    SET_SEQUENCE(state, val) {
      state.sequence = val;
    },
    SET_OBSERVATION(state, val) {
      state.observation = val;
    },
    SET_OBSERVATION_PROVIDER(state, val) {
      state.providerObservation = val;
    },

    SET_LOADING(state, val) {
      state.isLoading = val;
    },
    SET_STORES(state, val) {
      state.store = val;
    },
    MODIFY_PRIORITY_PHONE(state, val) {
      state.dataClienteDNI.phones[val.position].priority = val.value;
    },
    MODIFY_PRIORITY_MAIL(state, val) {
      state.dataClienteDNI.mails[val.position].priority = val.value;
    },
    MODIFY_PRIORITY_DIRECTION(state, val) {
      state.dataClienteDNI.directions[val.position].priority = val.value;
    },

    SET_DATABYDNI(state, val) {
      state.dataClienteDNI = val;
    },

    addService(state, service) {
      state.listServices.push(service);
    },


    resetDataClienteDNI(state, val) {
      state.dataClienteDNI = val;
    },


    RESET_OBSERVATIONS(state, val) {
      state.observation = val;
      // state.providerObservation = val;
    },
    SET_DATA_ADMINOS(state, val) {
      state.dataAdminOS = val;
    },
    SET_DATA_PROJECTS(state, val) {
      state.dataProjects = val;
    },
    SET_STORE_NAME(state, val) {
      state.storeName = val;
    }
  },
  actions: {

    SET_OBSERVATION({ commit }, payload) {
      commit("SET_OBSERVATION", payload);
    },
    SET_STORES({ commit }, payload) {
      commit("SET_STORES", payload);
    },



  },
  modules: {
    module,
  },
  plugins: [
    createPersistedState({

      paths: ["module.tokenAuth", "module.username", "module.store", "module.perfil", "module.options", "module.idProvider",
        "module.name","module.token"],


    }),
  ],
});
export default store;
const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}
